import React from 'react';
import {
    Card,
    CardContent,
    Grid,
    Typography,
    TextField,
    Autocomplete
} from '@mui/material';
import { Timezones, Countries } from 'components/Custom/Timezones'; // Adjust path as necessary
import '../../css/components/Profile/WorkflowInformation.css'; // Ensure this path is correct
import { useTranslation } from "react-i18next";

const WorkflowInformation = ({
    user, isEditable, handleInputChange
}) => {
    const { t } = useTranslation();

    return (
        <Card className="workflow-info-card">
            <CardContent>
                {/* Timezone Selector with Autocomplete */}
                <Grid container spacing={2}>
                    <Grid item sm={2} className="workflow-info-grid">
                        <Typography variant="body2" color="primary">
                            {t("profile.timezone")}
                        </Typography>
                    </Grid>
                    <Grid item sm={10}>
                        {isEditable ? (
                            <Autocomplete
                            options={Timezones}
                            getOptionLabel={(option) => option || ''}
                            value={user.timezone || null}
                            onChange={(event, newValue) => 
                                handleInputChange({ target: { name: 'timezone', value: newValue || '' } })}
                            renderInput={(params) => (
                                <TextField 
                                    {...params} 
                                    variant="outlined" 
                                    fullWidth 
                                    placeholder="Select or type a timezone"
                                    InputProps={{ 
                                        ...params.InputProps, 
                                        className: "dropdown-select-input-prop" // Apply global input styling
                                    }}
                                />
                            )}
                            classes={{
                                paper: "dropdown-select-input-prop",           // Container
                                listbox: "dropdown-select-input-prop-listbox", // List items container
                                option: "dropdown-select-input-prop-option"    // Individual options
                            }}
                        />
                        
                        ) : (
                            <Typography>{user.timezone}</Typography>
                        )}
                    </Grid>
                </Grid>

                {/* Country Selector with Autocomplete */}
                <Grid container spacing={2} className="workflow-info-margin">
                    <Grid item sm={2} className="workflow-info-grid">
                        <Typography variant="body2" color="primary">
                            {t("profile.location")}
                        </Typography>
                    </Grid>
                    <Grid item sm={10}>
                        {isEditable ? (
                            <Autocomplete
                                options={Countries}
                                getOptionLabel={(option) => option || ''}
                                value={user.location || null}
                                onChange={(event, newValue) => 
                                    handleInputChange({ target: { name: 'location', value: newValue || '' } })}
                                renderInput={(params) => (
                                    <TextField 
                                        {...params} 
                                        variant="outlined" 
                                        fullWidth 
                                        placeholder="Select or type a location"
                                        InputProps={{ 
                                            ...params.InputProps, 
                                            className: "dropdown-select-input-prop" // Use global class
                                        }}
                                    />
                                )}
                                classes={{
                                    paper: "dropdown-select-input-prop" // Applies global class to dropdown
                                }}
                            />
                        ) : (
                            <Typography>{user.location}</Typography>
                        )}
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default WorkflowInformation;
